import { useWeb3React } from '@web3-react/core'
import { usePoll } from './usePoll'

export function useETHBalance() {
  const { account, library, chainId } = useWeb3React()

  const [balance] = usePoll(async () => {
    if (!!account && !!library) {
      return library.getBalance(account)
    }
  }, [account, library, chainId])
  return balance
}
